import { EditOutlined } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Tooltip
} from "@mui/material";
import { useTranslate } from "@refinedev/core";
import { EditButtonProps } from "@refinedev/mui";
import { config } from "config";
import React, { useState } from "react";
import { dataProvider } from "rest-data-provider";
import UserRole from "@warriortrading/warriortrading.hermes.common.feathers/enums/userRole";

/**
 * `<EditButton>` uses uses Material UI {@link https://mui.com/components/buttons/ `<Button>`} component.
 * It uses the {@link https://refine.dev/docs/core/hooks/navigation/useNavigation#edit `edit`} method from {@link https://refine.dev/docs/core/hooks/navigation/useNavigation `useNavigation`} under the hood.
 * It can be useful when redirecting the app to the edit page with the record id route of resource}.
 *
 * @see {@link https://refine.dev/docs/ui-frameworks/mui/components/buttons/edit-button} for more details.
 */

type ExtendedEditButtonProps = EditButtonProps & {
  userRole: number;
  dataUpdate: (e: any) => void;
};
export const RoomMembersEditBtn: React.FC<ExtendedEditButtonProps> = ({
  resource: resourceNameFromProps,
  recordItemId,
  hideText = false,
  accessControl,
  svgIconProps,
  meta,
  children,
  userRole,
  dataUpdate,
  onClick,
  ...rest
}) => {
  const translate = useTranslate();
  const apiUrl = config().server.api;
  const [open, setOpen] = useState(false);
  const [userRoleState, setUserRoleState] = useState(userRole);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSave = () => {
    dataProvider(apiUrl)
      .update({
        resource: "room-member",
        id: recordItemId ?? "",
        variables: {
          role: userRoleState,
          status: 0,
        },
      })
      .then(() => {
        dataUpdate(true);
      });
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Tooltip title="Edit">
        <Button
          onClick={handleClickOpen}
          startIcon={
            !hideText && (
              <EditOutlined sx={{ selfAlign: "center" }} {...svgIconProps} />
            )
          }
        >
          {hideText ? (
            <EditOutlined fontSize="small" {...svgIconProps} />
          ) : (
            children ?? translate("buttons.edit", "Edit")
          )}
        </Button>
      </Tooltip>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Room Member</DialogTitle>
        <DialogContent>
          <TextField
            required
            select
            value={userRoleState ?? ""}
            defaultValue={0}
            label="Role"
            margin="normal"
            onChange={(e) => {
              setUserRoleState(e.target.value as unknown as number);
            }}
          >
            {Object.values(UserRole)[0].map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
